// extracted by css-extract-rspack-plugin
export default {"button":"oQyue","icon":"JDSsP"};